import { render } from "./ManageTestimonials.vue?vue&type=template&id=2668a34a"
import script from "./ManageTestimonials.vue?vue&type=script&lang=js"
export * from "./ManageTestimonials.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__